
export enum AILayout {
    VOICE_ONLY = "VOICE_ONLY",
    CAMERA_LEFT = "CAMERA_LEFT",
    CAMERA_RIGHT = "CAMERA_RIGHT",
    SMALL_CAMERA_LEFT = "SMALL_CAMERA_LEFT",
    SMALL_CAMERA_RIGHT = "SMALL_CAMERA_RIGHT",
}
